import { Injectable } from '@angular/core';
import * as app from '../../assets/config/app.json';

@Injectable({
  providedIn: 'root'
})
export class ConfigService {

  constructor() { }

  get app(): any {
    return (app as any).default;
  }

}
